import { isFinite } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

import { CURRENCY_0 } from 'commons-vehicle/constants/currencyFormats.js';
import { PriceAmounts } from '@sm360/widget-commons-general';

const CONTENT_ZONE_GROUP = {
    LISTING: 'widget.listing.used',
    VDP: {
        NEW: 'widget.build.and.buy',
        USED: 'widget.vdp.used',
    },
};

const getSellingPriceLabel = () => {
    const contentZoneName = 'selling.price.label';
    let sellingPriceLabel = ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.LISTING, contentZoneName);

    if (!sellingPriceLabel || !sellingPriceLabel.getText()) {
        sellingPriceLabel =
            ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.VDP.NEW, contentZoneName) ||
            ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.VDP.USED, contentZoneName);
    }

    return (sellingPriceLabel && sellingPriceLabel.getText()) || LocaleService.t('VEHICLE_TILE.PRICE');
};

const Price = ({ amount, taxCodes, retail, taxesExcludedDisclaimer, includedDisclaimer }) => {
    const taxesDisclaimer = taxesExcludedDisclaimer || LocaleService.t('VEHICLE_TILE.TAXES', { taxCodes });
    return (
        <div className="listing-tile-all-price">
            <div className="listing-tile-all-price-title sr-text">
                <div className="is-bold">{getSellingPriceLabel()}</div>
                {includedDisclaimer && <div className="disclaimer-included is-light">{includedDisclaimer}</div>}
            </div>
            <div className="listing-tile-all-price-info">
                {retail > 0 &&
                    retail > amount && (
                        <p className="listing-tile-all-price-retails rebated">
                            <PriceAmounts price={LocaleService.l(retail, CURRENCY_0)} />
                        </p>
                    )}
                <div className="price is-bold is-price">
                    *{isFinite(amount) && <PriceAmounts price={LocaleService.l(amount, CURRENCY_0)} />}
                </div>
                {taxesDisclaimer && <div className="disclaimer-price is-light">{taxesDisclaimer}</div>}
            </div>
        </div>
    );
};

Price.defaultProps = {
    retail: 0,
    taxesExcludedDisclaimer: '',
    includedDisclaimer: '',
};

Price.propTypes = {
    amount: PropTypes.number.isRequired,
    taxCodes: PropTypes.string.isRequired,
    retail: PropTypes.number,
    taxesExcludedDisclaimer: PropTypes.string,
    includedDisclaimer: PropTypes.string,
};

Price.displayName = 'Price';

export default Price;
